module.exports = __webpack_public_path__ + "img/049-ecuador.166ee268.svg";